import * as React from 'react'
import styled, { css } from 'styled-components'
import theme from 'theme'

type Props = {
  title: string
  value: string
  link: string
  subtitle?: string
  iconScale?: number
  icon: any
}

export default function Service(props: Props) {
  return (
    <Wrapper className="Service" $iconScale={props.iconScale}>
      <div className="title">{props.title}</div>
      <div className="group">
        {props.icon}
        <div className="info">
          <div className="main">
            <a href={`${props.link}`} target="_blank" rel="noreferrer">
              {props.value}
            </a>
          </div>
          <div className="subtitle">{props.subtitle}</div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $iconScale?: number }>`
  > .title {
    ${theme.ty('rc-s', 'bold')}
    margin-bottom: ${theme.spacing('xs')};
    @media (min-width: ${theme.ms.MD}px) {
      ${theme.ty('rc-l', 'bold')}
    }
  }
  > .group {
    display: flex;
    gap: ${theme.spacing('xs')};
    > svg {
      width: 18px;
      height: 22px;
      ${(p) =>
        p.$iconScale &&
        css`
          transform: scale(${p.$iconScale});
        `}
      path {
        fill: black;
      }
    }
    > .info {
      > .main {
        ${theme.ty('rc-s', 'bold')}
        text-decoration: underline;
        margin-bottom: 2px;
        @media (min-width: ${theme.ms.MD}px) {
          ${theme.ty('rc-base', 'bold')}
        }
      }
      > .subtitle {
        ${theme.ty('rc-xs')}
        color: ${theme.colors.shade.b1};
        @media (min-width: ${theme.ms.MD}px) {
          ${theme.ty('rc-s')}
        }
      }
    }
  }
`
